import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import type { ChatSettings } from './chat.types';
import { DEFAULT_CHAT_SETTINGS } from './chat.types';

interface UseChatSettingsResult {
  settings: ChatSettings;
  loading: boolean;
}

export function useChatSettings(): UseChatSettingsResult {
  const [settings, setSettings] = useState<ChatSettings>(DEFAULT_CHAT_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const { data } = await supabase
        .from('content_blocks')
        .select('content')
        .eq('block_key', 'chat:settings')
        .maybeSingle();

      if (data?.content) {
        setSettings({ ...DEFAULT_CHAT_SETTINGS, ...(data.content as Partial<ChatSettings>) });
      }
      setLoading(false);
    }
    void load();
  }, []);

  return { settings, loading };
}
